/**
 * 只有这里允许写平台相关代码
 */

import config from "config";
import { ReceiverType } from "./types";

// Storage
export const getUserNo = () => localStorage.getItem("STUDENTNO") || "";
export const getUserName = () => localStorage.getItem("STUDENTNAME") || "";

// Config
export const getSocketUrl = () =>
    `${config.WsHost}student/websocket/${getUserNo()}/chat/TEA_TO_STU`;

export const CurrentUserType = ReceiverType.Student;
export const OppositeUserType = ReceiverType.Teacher;

export { customerCode } from "API";

// Utils

export { errorMessage, default as useRequest } from "Utils/useRequest";
export { default as useRequestFn } from "Utils/useRequestFn";
export { FormatTime, humanFileSize, isTrue, getStrBySlice } from "Utils/filter";

export { default as useDeviceType } from "Utils/useDeviceType";
export { default as useWebsocket } from "Utils/useWebsocket";
export { default as useModalHandler } from "Utils/useModalHandler";

// Components
export { ResultMessage } from "components/ResultMessage";
export { default as CustomEmpty } from "components/CustomEmpty";

// APIs
export {
    deleteMessage,
    getCourseList,
    SessionType,
    closeSession,
    closeSessionBatch,
    getContactList,
    getSessionList,
    openSession,
    setHasRead,
    findHistoryMsg,
    getSessionInfo
} from "API/chat";

export { CourseWareTypeList } from "API/courseware";
export { uploadToQiNiu } from "API";

export function getToken() {
    return localStorage.getItem("token");
}
